import type { Product } from "@dransay/api";
import { CATEGORIES } from "@dransay/api/models";

// Returns the correct unit (mg/ml, mg or %) for THC/CBD based on product category

export function getThcCbdUnit(
	category?: Product["category"],
): "mg" | "%" | "mg/ml" {
	switch (category) {
		case CATEGORIES.INHALATIONS_EXTRACT:
		case CATEGORIES.EDIBLES:
		case CATEGORIES.DRINKABLES:
		case CATEGORIES.CAPSULES:
			return "mg";
		case CATEGORIES.EXTRACTS:
			return "mg/ml";
		default:
			return "%";
	}
}
